<template lang="pug">
  .color-wonder-info(v-if="product.id")
    ColorWonderPdpProductInfo(v-if="!(breakpoint == 'mobile' || breakpoint == 'tablet')")
    PdpPriceModule.xs-mb-50m(v-if="showPriceModule")

    .swatches-wrap(v-if="isMobileBreakpoint")
      PdpSwatchSelectorGrid

    .desc-wrap
      ul.value-props.xs-f-small.max-at-tweak(v-if="cmsSettings?.valueProps?.length")
        li.xs-f-small.max-at-tweak(v-for="(prop, index) in cmsSettings.valueProps" :key="index")
          MrIcon(:name="prop.iconName" :fill="false" style="width: 1.5em;")
          | &nbsp;{{prop.text}}
      p.short-desc.xs-f-small.md-f-medium.max-at-tweak(itemprop="description") {{ shortDescription }}

    .swatches-wrap(v-if="breakpoint != 'mobile' && breakpoint != 'tablet'")
      PdpSwatchSelectorGrid

    .missing-advisor(v-if="!advisorCompleted")
      button.missing-advisor-cta.mr-btn.btn-secondary.btn-round.xs-f-small.max-at-tweak(type="button" @click="trackMREventAndRedirect( 'Find your shade - clicked' ,'/color-advisor?rectype=color')")
        span Find your shade
        MrIcon.ml-75m(name="arrow-right" height="0.8em")

</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import PdpPriceModule from "@components/PDP/PdpPriceModule";
  import PdpSwatchSelectorGrid from "@components/PDP/PdpSwatchSelectorGrid";
  import MrIcon from '@components/MrIcon';
  import ColorWonderPdpProductInfo from "../ColorWonderPdpProductInfo";

  export default {
    name: "ColorWonderPdpSide",

    components: {
      ColorWonderPdpProductInfo,
      PdpPriceModule,
      PdpSwatchSelectorGrid,
      MrIcon,
    },

    computed: {
      ...mapState('global', ['windowData']),
      ...mapState('customer', ['cdata']),
      ...mapState('pdp', [
        'product',
        'tones',
        'toneMap',
        'showPriceModule'
      ]),
      ...mapState('colorAdvisor', ['answers', 'advisorCompleted', 'colorMatches']),
      ...mapState('cms', ['cmsSettings']),

      breakpoint() {
        return this.windowData.breakpoint;
      },

      isMobileBreakpoint() {
        return this.breakpoint == 'mobile' || this.breakpoint =='tablet';
      },

      shortDescription() {
        return this.product?.desc?.short;
      },

      isBestMatch() {
        return this.advisorCompleted && this.cdata && this.cdata.bestColorMatch && this.cdata.bestColorMatch.code == this.product.code;
      },

      matchType() {
        var type = {};
        var labelMap = {
          bestMatch: "Best Match",
          mostPopular: "Most Popular",
          customerMatch: "Your Pick",
          translatorMatch: "Translator Results",
          coloristMatch: "Colorist's Choice"
        };

        if (this.colorMatches.data && this.product) {
          Object.keys(this.colorMatches.data).forEach(key => {
            if (this.colorMatches.data[key] && this.colorMatches.data[key].code == this.product.code) {
              type.key = key;
              type.label = labelMap[key];
            }
          });
        }

        return type;
      }
    },

    mounted() {
      this.updateColorMatches();
      this.initColorAdvisor();
    },

    methods: {
      ...mapActions('colorAdvisor', ['initColorAdvisor', 'updateColorMatches']),
      ...mapActions('pdp', ['openPlaygroundModal']),

      seeMoreColors(viewOnModel, elementRef) {
        this.openPlaygroundModal({
          props: {
            viewOnModel: viewOnModel
          },
          returnFocusElement: elementRef
        });
      }
    },
  };
</script>

<style scoped lang="stylus">
  .color-wonder-info
    .desc-wrap
    .swatches-wrap
      border-top 1px solid ui-color-5
      padding 0.5em 0

    .desc-wrap
      padding 1.5em 0
      color brand-color-8

      .value-props
        padding-bottom 1.5em

        li
          position relative
          line-height 1.5em
          padding-bottom 0.5em
          margin-left 1.5em

          .mr-icon
            position absolute
            top 0.1em
            left -1.5em

          &:last-child
            padding-bottom 0

    .missing-advisor
      @media mq-mobile
        padding 1em 5%

      .missing-advisor-cta
        display flex
        align-items center!important
        text-transform none
        padding 0.8em 1.6em
        letter-spacing: -0.5px

    @media mq-mobile
      .desc-wrap
        padding 1.5em 5%

</style>
